import script from "./3d-packing-viewer.vue?vue&type=script&setup=true&lang=js"
export * from "./3d-packing-viewer.vue?vue&type=script&setup=true&lang=js"

import "./3d-packing-viewer.vue?vue&type=style&index=0&id=30ef9fb1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ef9fb1"]])

export default __exports__